import { CellRenderers, formatters, type ServerColDef } from '@cmg/data-grid';

import { RolodexRecordStatus } from '../../../../../graphql';
import type { UnderwriterEmployeeFragment } from '../components/SalesCoverageGrid/graphql/__generated__';

export const getStatusColor = (status: RolodexRecordStatus) => {
  switch (status) {
    case RolodexRecordStatus.Effective:
      return 'success';
    case RolodexRecordStatus.Deleted:
      return 'error';
    default:
      return 'disabled';
  }
};

const statusColDef: ServerColDef<UnderwriterEmployeeFragment> = {
  field: 'status',
  headerName: 'Status',
  valueFormatter: formatters.enumValueFormatter,
  minWidth: 120,
  cellRenderer: CellRenderers.DotStatusCellRenderer,
  cellRendererParams: { getStatusColor },
  filter: 'agSetColumnFilter',
  filterParams: {
    values: Object.values(RolodexRecordStatus),
    valueFormatter: formatters.enumValueFormatter,
  },
};

export default statusColDef;
